import { EnvironmentBanner, ImpersonationBanner } from '@korint/folio';
import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';

export const EMBEDDED_FUNNEL_RESIZE_MESSAGE_TYPE = 'korint:embedded-funnel-resize';

export function EmbeddedAnonymousLayout() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.parent === window || !containerRef.current) {
      return;
    }

    const reportHeight = ([entry]: ResizeObserverEntry[]) => {
      window.parent.postMessage(
        { type: EMBEDDED_FUNNEL_RESIZE_MESSAGE_TYPE, height: entry.target.scrollHeight },
        '*',
      );
    };

    const observer = new ResizeObserver(reportHeight);
    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="w-full">
      <ImpersonationBanner />
      <EnvironmentBanner />
      <Outlet />
    </div>
  );
}
